/* KOMTO · высота ряда меню в липкой шапке — 2026-08-26.

   Тема обрезает ряд навигации по переменной:

     .cc-header--sticky .main-menu__content {
       max-height: var(--menu-height); overflow: hidden;   (assets/main.css)
     }

   а саму переменную считает по тому же самому элементу:

     this.style.setProperty('--menu-height', this.menu.clientHeight + 16 + 'px')
                                                    (assets/main.js, setMenuHeight)

   То есть высоту меню меряют сквозь собственную обрезку. Пока ряд раскрыт,
   всё сходится. Но setMenuHeight вызывается ещё и на каждом ресайзе и смене
   брейкпоинта, без проверки состояния шапки: замер, попавший в те 300 мс,
   пока ряд схлопывается или разворачивается, возвращает промежуточное
   значение — и оно застревает. Ряд навигации остаётся срезанным по середине
   букв, а компенсация `margin-bottom: var(--menu-height)` у спрятанной шапки
   становится короче настоящего ряда, отчего контент подпрыгивает.
   Единственная защита в теме — `if (this.menu.clientHeight)` — ловит ровно
   ноль и ничего между.

   scrollHeight обрезкой не задет: при `max-height: 0` он всё равно отдаёт
   высоту содержимого. Считаем по нему — значение не зависит от того, в каком
   состоянии сейчас шапка, поэтому пересчитывать можно когда угодно. */
(function () {
  var DESKTOP = '(min-width: 769px)';
  var GAP = 16; // те же 16px, что тема добавляет к высоте строки

  function fix() {
    if (!window.matchMedia(DESKTOP).matches) return;
    var header = document.querySelector('store-header');
    if (!header) return;
    var menu = header.querySelector('.main-menu__content');
    if (!menu) return;

    var natural = menu.scrollHeight;
    if (!natural) return;

    var want = natural + GAP;
    var have = parseFloat(header.style.getPropertyValue('--menu-height')) || 0;
    // Порог заодно обрывает цикл: наша правка анимирует max-height и вернётся
    // сюда через transitionend, но со второго раза разницы уже не будет.
    if (Math.abs(have - want) < 1) return;
    header.style.setProperty('--menu-height', want + 'px');
  }

  function watch() {
    var header = document.querySelector('store-header');
    if (!header) return;
    var menu = header.querySelector('.main-menu__content');
    if (menu) {
      menu.addEventListener('transitionend', function (e) {
        if (e.propertyName === 'max-height') fix();
      });
    }
    // После своих обработчиков темы: наш слушатель добавлен позже, значит и
    // вызывается позже. updateHeaderHeights ещё и откладывает часть работы на
    // длительность анимации — поэтому повторяем с запасом.
    window.addEventListener('on:debounced-resize', function () {
      fix();
      setTimeout(fix, 400);
    });
    window.addEventListener('on:breakpoint-change', function () {
      fix();
      setTimeout(fix, 400);
    });
    // Свой Inter Tight приезжает после первой отрисовки, и строка меню с ним
    // выше, чем с запасным системным шрифтом.
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fix);
    setTimeout(fix, 500);
    fix();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watch);
  } else {
    watch();
  }
})();
